export default "__VITE_ASSET__CnSZ3aaI__"